import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../../graphql/GraphQlProvider';
import { Report } from '../../../../graphql/reports.datatypes';
import { gqlReport } from '../getReportByKey.api';

export interface CreateReportVars {
    data: {
        name: string
        query: string
        url_key: string
        shared: boolean
        user: {
            connect: number,
        }
    };
}

export interface CreateReportData {
    createReport: Report
}

export const CREATE_REPORT_MUTATION = gql`
    mutation createReport($data: CreateReportInput!) {
        createReport(data: $data) {
            ${gqlReport}
        }
    }
`;

export const createReport = () => useMutation<CreateReportData, CreateReportVars>(
  CREATE_REPORT_MUTATION,
    {
        update: updateCacheByType('Report'),
    }
);

export default createReport;